export class QueryParameter {
    Name: string;
    Value: null | number | string;

    constructor(name: string = null, value: any = null){
        this.Name = name;
        this.Value = value;
    }

    GetParametersString(parameters: QueryParameter[]){
        let parametersString = '';
        if(parameters != null && parameters.length > 0){
            parametersString += '?';
            parameters.forEach(parameter => {
                if(parameter.Value){
                    if(typeof(parameter.Value) == 'string' || typeof(parameter.Value) == 'number')
                        parametersString += parameter.Name + '='  +parameter.Value + '&';
                    else parametersString += this.getValue(parameter.Value);
                }
            })
            parametersString = parametersString.substring(0, parametersString.length - 1);
        }
        return parametersString;
    }

    private getValue(parameterValue){
        if(typeof(parameterValue) == 'string' || typeof(parameterValue) == 'number')
            return parameterValue;

        if(parameterValue['day'] != null){
            return 'day=' + parameterValue['day'] + '&month=' + parameterValue['month'] + '&year=' + parameterValue['year'] + '&';
        }
        let parameters = '';
        for(let key in parameterValue){
            parameters += key + '=' + parameterValue[key] + '&';
        }
        return parameters;
    }

    GetParametersRouteString(parameters: QueryParameter[]){
        let parametersString = '';
        if(parameters != null && parameters.length > 0){
            parametersString += '/';
            parameters.forEach(parameter => {
                if(parameter.Value != null){
                    if(typeof(parameter.Value) == 'string' || typeof(parameter.Value) == 'number' || typeof(parameter.Value) == 'boolean')
                        parametersString += parameter.Value + '/';
                    else if(typeof(parameter.Value) == 'object' && parameter.Value['day'] != null)
                        parametersString += parameter.Value['day'] + '-' + parameter.Value['month'] + '-' + parameter.Value['year'] + '/';
                }
            })
            parametersString = parametersString.substring(0, parametersString.length - 1);
        }
        return parametersString;
    }
}
